import React from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { UseFormReturn } from 'react-hook-form'
import { Region } from 'msp-integrations'
import { Field, Button } from 'msp-components'
import type { FieldsConfiguration } from 'msp-components'

const messages = defineMessages({
  helpDescription: {
    id: 'cancellation_form.help.description',
    defaultMessage:
      'If you wish to cancel only specific items from your order, please list them here.'
  },
  notice: {
    id: 'cancellation_form.notice',
    defaultMessage:
      'After submitting, you will immediately receive confirmation of the receipt of your withdrawal by email.'
  },
  prepare: {
    id: 'cancellation_form.button.prepare',
    defaultMessage: 'Prepare cancellation'
  }
})

type FormStepProps = {
  form: UseFormReturn<any>
  fieldConfig: FieldsConfiguration
  headlineRegion: any
  introText?: string
  onPrepare: () => void
}

const FormStep = ({
  form,
  fieldConfig,
  headlineRegion,
  introText,
  onPrepare
}: FormStepProps) => {
  const { formatMessage } = useIntl()
  const fieldNames = Object.keys(fieldConfig)
  return (
    <>
      {headlineRegion?.components?.length > 0 && (
        <div className='mb-6'>
          <Region noWrapper region={headlineRegion} />
        </div>
      )}
      {introText && (
        <p className='font-Roboto text-16 mb-6 text-black'>{introText}</p>
      )}
      <form
        onSubmit={form.handleSubmit(onPrepare)}
        data-cy='cms-cancellation-form'
        data-testid='cancellation-form'
        className='flex flex-col gap-4'
      >
        {fieldNames.map((name) => (
          <Field
            key={name}
            control={form.control}
            config={fieldConfig[name]}
            error={form.formState.errors?.[name]}
          />
        ))}
        <p className='font-Roboto text-14 text-machine4-100 -mt-2'>
          {formatMessage(messages.helpDescription)}
        </p>
        <p className='font-Roboto text-14 mt-4 text-black'>
          {formatMessage(messages.notice)}
        </p>
        <div className='mt-4'>
          <Button
            isSubmit
            isDisabled={form.formState.isSubmitting}
            isLoading={form.formState.isSubmitting}
            onClick={() => form.clearErrors(fieldNames)}
          >
            {formatMessage(messages.prepare)}
          </Button>
        </div>
      </form>
    </>
  )
}

export default FormStep
